import { MenuEntry } from '@src/menu-entry';

export default [
    MenuEntry.create()
        .setRoute('price_overview'),
    MenuEntry.create()
        .setRoute('price_set_list')
        .setAdditionalRoutes([
            'price_set_create',
            'price_set_edit',
        ]),
    MenuEntry.create()
        .setRoute('price_promotion_list')
        .setAdditionalRoutes([
            'price_promotion_edit',
            'price_promotion_create',
        ]),
    MenuEntry.create()
        .setRoute('procurement_missing_cost_prices')
        .setAdditionalRoutes([
            'procurement_edit_missing_cost_prices',
        ]),
    MenuEntry.create()
        .setRoute('price_reset_recommendation_list'),
    MenuEntry.create()
        .setRoute('damaged_price_promotion_list')
        .setAdditionalRoutes([
            'damaged_price_promotion_create',
            'damaged_price_promotion_edit',
        ]),
    MenuEntry.create()
        .setRoute('show_suggested_retail_price_filter_list')
        .setAdditionalRoutes([
            'show_suggested_retail_price_filter_create',
            'show_suggested_retail_price_filter_edit',
        ]),
];
